import { render, staticRenderFns } from "./mutationfrequency.vue?vue&type=template&id=64a85628&scoped=true"
import script from "./mutationfrequency.vue?vue&type=script&lang=js"
export * from "./mutationfrequency.vue?vue&type=script&lang=js"
import style0 from "./mutationfrequency.vue?vue&type=style&index=0&id=64a85628&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a85628",
  null
  
)

export default component.exports